<template>
  <div>

    <div class="columns">
      <div :class="`column ${columnClasses}`">
        <div>
          <span class="tag is-primary is-light is-small">Parlay</span>
          &nbsp;
          <span class="is-hidden-tablet">Risking {{ parlay.risk }} Unit{{ parlay.risk > 1 ? 's' : '' }} To Win {{ parlay.gain }}</span>
        </div>
      </div>
    </div>

    <div class="columns is-vcentered is-mobile">
      <div :class="`column ${columnClasses}`">
        <div v-for="(bet, i) in parlay.bets" :key="bet.id" :class="i !== parlay.bets.length - 1 ? 'mb-4' : ''">
          <p class="heading">{{ bet.awayTeam }} v. {{ bet.homeTeam }}</p>
          <p class="title is-6 is-size-4-tablet">{{ bet.body }}</p>
        </div>
      </div>

      <div class="column has-text-centered is-hidden-mobile">
        <p class="heading">Risking {{parlay.risk}} Unit{{parlay.risk > 1 ? 's' : ''}}</p>
        <p class="title is-6 is-size-4-tablet">To Win {{parlay.gain}}</p>
      </div>

      <div class="column has-text-right">
        <p class="heading">
          {{ date }}
          <span class="no-wrap">{{time}}</span>
        </p>
        <p v-if="!isClosed" class="title is-6 is-size-4-desktop">
          <CountDown @eventStarted="isClosed = true" :date-time="parlay.dateTime" />
        </p>
        <p v-else><span class="tag is-large is-light is-primary is-hidden-mobile">Closed</span></p>
      </div>
    </div>

    <div v-if="instructions" class="columns">
      <div :class="`column ${columnClasses}`">
        <div class="content">
          <p>
            <b-icon icon="information" type="is-primary" /><em>{{instructions}}</em>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountDown from '@/components/members/CountDown';

export default {
  components: {
    CountDown
  },
  props: {
    parlay: Object,
    columnClasses: String
  },
  data() {
    return {
      isClosed: false,
    }
  },
  computed: {
    date: function () {
      return new Date(this.parlay.dateTime).toLocaleDateString();
    },
    time: function () {
      return new Date(this.parlay.dateTime).toLocaleTimeString('en-us', {hour: '2-digit', minute: '2-digit'});
    },
    instructions: function () {
      if (!('instructions' in this.parlay)) {
        return 'No instructions';
      }

      let cleanInstructions = this.parlay.instructions.replace(/(N\/A)/g, '');

      let params = new URLSearchParams(cleanInstructions);

      if (params.has('instructions')) {
        return params.get('instructions');
      }

      return cleanInstructions;
    }
  }
}
</script>
